module.exports = __webpack_public_path__ + "static/img/卡片_未选中状态_2@2x.d35d119c.png";